import React, { Component } from 'react';
import '../assets/custom.css';
import LoginFields from '../LoginFields/LoginFields';
import { withRouter } from 'react-router-dom';
import logo from "../assets/images/logo_avenuepm.png";
import logo_ideasthatwork from "../assets/images/logo-bottom.png";
import REST from "../Shared/REST";
import pinIcon from "../assets/images/pin.png";
import {Modal} from "react-bootstrap";
import closeModalIcon from "../assets/images/ico-close.png";
import DialogBox from "../Shared/DialogBox";
import TRACKING from "../Shared/DataTrackingPoints";
import {GAME_URL} from "../Shared/Consts";
const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30%'
    }
};

class GetUserNameComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            email: "",
            submitting: false,
            usernameEmailError: '',
            modalDialog:false,
            responseContent:'',
            analytics: {
                type: null,
                metadata: null,
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
    }

    async componentDidMount(){
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleChange(event) {
        console.log(event.target.value);
        this.setState({ email: event.target.value });
    }


    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validate() {
        let valid = true;
        if(this.state.email === null || this.state.email.length === 0||!this.validateEmail(this.state.email)){
            valid = false;
            this.setState({usernameEmailError: 'validationRed' });
        }
        else{
            this.setState({usernameEmailError: '' });
        }
        return valid;
    }

    async handleSubmit(event) {
        if(this.validate()) {
            await this.setState({
                submitting: true
            });
            REST.resetStudentUsername({email: this.state.email}).then((res) => {
                this.setState({ submitting: false, usernameEmailError: '',modalDialog: true, responseContent:'An email with the username has been sent to the email provided.',infoWarning: null});
            }).catch((e) => {
                this.setState({
                    submitting: false
                });
            });
        }
    }

    handleLoginEnterKeyPress = (event) => {
        if(event.key == 'Enter'){
            this.handleSubmit();
        }
    }

    render() {
        return (
            <div>
                <h1 className="homePage"><img src={logo} alt="AvenuePM" border="0" /></h1>
                <div className="section bgGreen mainLogin">
                    <div className="container">
                        <div>
                            <h2 className="width">Get UserName and Password</h2>
                            <div className="formContainer">
                                <div>
                                    <div id="pinIcon">
                                        <img src={pinIcon} alt="Pin Icon" border="0"/>
                                    </div>
                                    <div className="formLogin">
                                        <div className="input-title">Please input your email</div>
                                        <input type="text" value={this.state.email} className="form-control"
                                               onChange={this.handleChange} placeholder="Email"
                                               onKeyPress={this.handleLoginEnterKeyPress} required autoFocus/>
                                        <br/>
                                        <div className={"row"}>
                                            <div className={"col-md-12 col-xs-12"}>
                                                <div className={"row"}>
                                                    {this.state.submitting ?
                                                        "Please Wait...":
                                                        <button onClick={this.handleSubmit} name="Login"
                                                                className="btn btn-primary loginButton">Submit
                                                        </button>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <DialogBox notificationModal modalOpen={this.state.modalDialog}
                                               infoWarning={this.state.infoWarning}
                                               sectionContent={this.state.responseContent} htmlSection
                                               closeClick={(active) => {
                                                   this.setState({modalDialog: active});
                                                   window.location = GAME_URL;
                                               }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <footer>
                    <div className="container">
                        <div className="col-lg-12">
                            <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the North Carolina State University and Penn State University. (v.1.0.2)</p>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default withRouter(GetUserNameComponent);